var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgAlert = function SvgAlert(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 35,
    viewBox: "0 0 36 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 17.5,
    r: 17.5,
    fill: "#7A7A7A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1914 24.4506H20.1129C20.1129 23.3894 19.2526 22.5291 18.1914 22.5291V24.4506ZM18.1914 24.6427L18.1909 26.5642C18.7006 26.5644 19.1895 26.362 19.5499 26.0016C19.9104 25.6412 20.1129 25.1524 20.1129 24.6427H18.1914ZM18 24.6427H16.0785C16.0785 25.7037 16.9385 26.5639 17.9995 26.5642L18 24.6427ZM18 24.4506V22.5291C16.9388 22.5291 16.0785 23.3894 16.0785 24.4506H18ZM20.0172 11C20.0172 9.93878 19.1569 9.07849 18.0957 9.07849C17.0345 9.07849 16.1742 9.93878 16.1742 11H20.0172ZM16.1742 18.686C16.1742 19.7473 17.0345 20.6076 18.0957 20.6076C19.1569 20.6076 20.0172 19.7473 20.0172 18.686H16.1742ZM16.2699 24.4506V24.6427H20.1129V24.4506H16.2699ZM18.1919 22.7212L18.0005 22.7212L17.9995 26.5642L18.1909 26.5642L18.1919 22.7212ZM19.9215 24.6427V24.4506H16.0785V24.6427H19.9215ZM18 26.3721H18.1914V22.5291H18V26.3721ZM16.1742 11V18.686H20.0172V11H16.1742Z",
    fill: "white"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAlert);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "apps/static/media/alert.c07dc36d02ed4a98537b6b1b65c987d6.blank.svg";